<div class="container">
  <ngx-spinner type="ball-atom"></ngx-spinner>

  <div class="search-form">
    <form (ngSubmit)="onSearch()" class="search-form">
      <div class="search-fields">
        <mat-form-field appearance="fill">
          <mat-label>Name</mat-label>
          <input matInput [(ngModel)]="searchTerm" name="searchTerm" placeholder="Search by name" appTextNormalize>
        </mat-form-field>
      </div>

      <div class="search-actions">
        <mat-checkbox [(ngModel)]="showExtraData" name="showExtraData" color="primary">Show Extra Data</mat-checkbox>
        <div class="search-actions-spacer"></div>
        <button mat-flat-button type="button" class="nrg-error-flat-button" (click)="onClear()" [disabled]="!hasSearchCriteria">
          <mat-icon>clear</mat-icon>
          Clear
        </button>
        <button mat-flat-button color="primary" type="submit" [disabled]="!searchTerm.trim()">
          <mat-icon>search</mat-icon>
          Search
        </button>
      </div>
    </form>
  </div>

  <div class="table-container">
    <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z2" [hidden]="!dataSource.data || dataSource.data.length === 0">
      <ng-container matColumnDef="matchedYearsIcon">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let item">
          @if (item.matchedYearsTooltip) {
            <mat-icon class="cell-info-icon" [matTooltip]="item.matchedYearsTooltip">info_outline</mat-icon>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="code">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Internal ID</th>
        <td mat-cell *matCellDef="let item">{{ item.code }}</td>
      </ng-container>

      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
        <td mat-cell *matCellDef="let item">
{{ item.name }}
        </td>
      </ng-container>

      <ng-container matColumnDef="entityType">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Type</th>
        <td mat-cell *matCellDef="let item">
          <span class="type-badge" [ngClass]="Helpers.getEntityTypeBadgeClass(item.entityType)">
            {{ Helpers.getEntityTypeText(item.entityType) }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="extraData">
        <th mat-header-cell *matHeaderCellDef>Extra Data</th>
        <td mat-cell *matCellDef="let item">
          <ul class="list-column">
            @for (d of getExtraDataItems(item); track $index) {
              <li>{{ d.label }}</li>
            }
          </ul>
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let item">
          <button mat-icon-button (click)="onConnect(item)">
            <mat-icon>{{ isSelected(item) ? 'check_box' : 'check_box_outline_blank' }}</mat-icon>
          </button>
          @if (canOpenInNewTab(item)) {
            <button mat-icon-button (click)="onOpenInNewTab(item, $event)"
                    matTooltip="Open the director in a new tab to check the CV">
              <mat-icon>open_in_new</mat-icon>
            </button>
          }
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;" [ngClass]="{'right-row': isSelected(row)}"></tr>
    </table>

    @if (hasSearched && dataSource.data.length === 0) {
      <div class="empty-state">
        <p>No results found matching your criteria.</p>
        <button mat-flat-button color="primary" (click)="addNewRequested.emit()">
          <mat-icon>person_add</mat-icon>
          Create New Large Shareholder
        </button>
      </div>
    } @else if (!hasSearched) {
      <div class="empty-state">
        Search for an existing entity to add as a large shareholder.
      </div>
    }

    <mat-paginator
      [pageSize]="pageSize"
      [showFirstLastButtons]="true"
      [hidden]="!dataSource.data || dataSource.data.length === 0"
      aria-label="Select page">
    </mat-paginator>
  </div>
</div>
